module.exports = __webpack_public_path__ + "img/presentation_lobbyx.77f5a27d.webp";